import React, { useEffect, useRef } from 'react';
import { useFocusedField } from '../../../../contexts/focused-field-provider';
import { useScroll } from '../../../../contexts/scroll-provider';
export const Focusable = _ref => {
  let {
    children,
    fieldId
  } = _ref;
  const viewRef = useRef(null);
  const {
    scrollTo
  } = useScroll();
  const {
    focusedFieldId
  } = useFocusedField();
  useEffect(() => {
    if (viewRef.current && fieldId === focusedFieldId) {
      scrollTo(viewRef.current);
    }
  }, [scrollTo, fieldId, focusedFieldId]);
  return /*#__PURE__*/React.createElement("div", {
    ref: viewRef
  }, children);
};
//# sourceMappingURL=focusable.js.map